import { render, staticRenderFns } from "./listDetails.vue?vue&type=template&id=a01ab464&scoped=true&"
import script from "./listDetails.vue?vue&type=script&lang=js&"
export * from "./listDetails.vue?vue&type=script&lang=js&"
import style0 from "./listDetails.vue?vue&type=style&index=0&id=a01ab464&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01ab464",
  null
  
)

export default component.exports